module.exports = __webpack_public_path__ + "img/clean_precheck_1.cfdb980d.svg";